<template>
  <div class="wy-interactions-compare-metrics" v-loading="loading" element-loading-text="Loading...">
    <el-row>
      <el-col :span="6">
        <div class="wy-page-title-small">Trending Topics</div>
        <div class="wy-page-title">{{ $t(currentPageInfo.title) }}</div>
      </el-col>
      <el-col :span="18" align="right">
        <div v-if="activeStep == 3">
          <div class="step-back" @click="handleBack">Back</div>
          <el-button class="step-next" type="primary" @click="handleNewSearch">New Search</el-button>
        </div>
      </el-col>
    </el-row>

    <div v-show="activeStep!=3" class="wy-page-picker">
      <el-row v-show="activeStep < 3">
        <el-col :span="4">
          <div class="step-cancel" v-if="activeStep > 0" @click="handleNewSearch">Cancel</div><br>
        </el-col>
        <el-col :span="14">
          <el-steps ref="stepNav" :active="activeStep" align-center finish-status="success">
            <el-step v-bind:class="{'filled': isStep1Filled}" title="Comparison Period A"></el-step>
            <el-step v-bind:class="{'filled': isStep2Filled}" title="Comparison Period B"></el-step>
            <el-step v-bind:class="{'filled': isStep3Filled}" title="AI-Generated Topics"></el-step>
          </el-steps>
          <div v-show="activeStep==0">
            <div class="selected-date-rangeA">{{dateRangeDisplayA}}</div>
          </div>
          <div class="div-step1-select-range" v-show="activeStep==1">
            <div class="selected-date-rangeA is-success">{{dateRangeDisplayA}}</div>
            <div class="selected-date-rangeB">{{dateRangeDisplayB}}</div>
          </div>
          <div class="div-step1-select-range" v-show="activeStep==2">
            <div class="selected-date-rangeA is-success">{{dateRangeDisplayA}}</div>
            <div class="selected-date-rangeB is-success" v-bind:class="{'is-success': isStep1Filled}">{{dateRangeDisplayB}}</div>
          </div>
        </el-col>
        <el-col :span="6" align="right">
          <div class="step-back" @click="handleBack" v-if="backButtonEnabled">Back</div>
            <el-button class="step-next" type="primary" @click="handleNext" v-if="nextButtonEnabled">{{nextButtonText}}</el-button>
        </el-col>
      </el-row>

      <div class="step-content">
        <div v-show="activeStep==0">
          <div class="step-title">Select first date range</div>
          <div>
            <functional-calendar-a ref="calendarPickerA" :parent="module" />
          </div>
        </div>
        <div v-show="activeStep==1">
          <div class="step-title">Select second date range</div>
          <div>
            <functional-calendar-b ref="calendarPickerB" :parent="module" />
          </div>
        </div>
        <div v-show="activeStep==2">
          <div class="step-title">Choose AI-Generated Topics</div>
          <div class="div-no-topics-icon" v-if="noTopic"></div>
          <div class="div-no-topics-header" v-if="noTopic">No data found</div>
          <div class="div-no-topics-desc" v-if="noTopic">Try adjusting your date range or filters to find the information you’re looking for.</div>
          <wy-interactions-compare-metrics-topics v-if="topicList && topicList.length>0" ref="topicsPicker" :parent="module" :dataList="topicList" />
        </div>        
      </div>
    </div>

    <div v-if="activeStep==3">
      <wy-interactions-compare-metrics-result v-if="isReportDataReady" :parent="module" :dataA="performanceDataA" :dataB="performanceDataB" />
      <wy-interactions-compare-metrics-chart ref="compareMetricsChart" v-if="isReportDataReady" :parent="module" :dataA="chartDataA" :dataB="chartDataB" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import FunctionalCalendarA from './wy-interactions-compare-metrics-cal-a';
import FunctionalCalendarB from './wy-interactions-compare-metrics-cal-b';
import WyInteractionsCompareMetricsTopics from './wy-interactions-compare-metrics-topics';
import WyInteractionsCompareMetricsResult from './wy-interactions-compare-metrics-result';
import WyInteractionsCompareMetricschart from './wy-interactions-compare-metrics-chart';
import moment from 'moment';

export default Vue.extend({
  name: 'wy-interactions-compare-metrics',
  props: ['dateRanges', 'topics'],
  components: {
    'functional-calendar-a': FunctionalCalendarA,
    'functional-calendar-b': FunctionalCalendarB,
    'wy-interactions-compare-metrics-topics': WyInteractionsCompareMetricsTopics,
    'wy-interactions-compare-metrics-result': WyInteractionsCompareMetricsResult,
    'wy-interactions-compare-metrics-chart': WyInteractionsCompareMetricschart,
  },

  data() {
    return {
      module: this,
      loading: false,
      initDate: null,

      calendarA: {dateRange: {start: "", end: ""}},
      calendarB: {dateRange: {start: "", end: ""}},

      activeStep: -1,
      isStep1Filled: false,
      isStep2Filled: false,

      dateRangeDisplayA: 'Month Day, Year',
      dateRangeDisplayB: 'Month Day, Year',
      
      selecteTopicList: [],
      topicList: null,
      performanceDataA: null,
      performanceDataB: null,

      chartDataA: {},
      chartDataB: {},

      isReportDataReady: false,
      preMsgObj: null,

      noTopic: false,

      activeStepToViewName: {
        0: "Chose Comparison Period A",
        1: "Chose Comparison Period B",
        2: "Chose Conversation Topics",
        3: "Results View"
      }
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'config', 'isLoggedIn', 'currentPageInfo']),

    isStep3Filled() {
      return this.selecteTopicList.length > 0 && !this.noTopic;
    },

    backButtonEnabled() {
      return this.activeStep > 0;
    },

    nextButtonEnabled() {
      if(this.activeStep == 0) {
        return this.isStep1Filled;
      }
      else if(this.activeStep == 1) {
        return this.isStep2Filled;
      }
      else if(this.activeStep == 2) {
        return this.isStep3Filled;
      }
      return false;
    },

    nextButtonText() {
      return this.activeStep == 2 ? "Show results" : "Next";
    }
  },

  methods: {
    ...mapActions(['fetchChatTopics', 'fetchChatPerformance']),

    getCalendarDateRange() {
      return {
          dateStart: moment(this.calendarA.dateRange.start, 'YYYY-MM-D').format("YYYY-MM-DD"),
          dateEnd: moment(this.calendarA.dateRange.end, 'YYYY-MM-D').format("YYYY-MM-DD"),
          dateStartCompare: moment(this.calendarB.dateRange.start, 'YYYY-MM-D').format("YYYY-MM-DD"),
          dateEndCompare: moment(this.calendarB.dateRange.end, 'YYYY-MM-D').format("YYYY-MM-DD"),
        }
    },

    handleStepClick(e) {
      e.preventDefault();
      e.stopPropagation();
      let target = e.target.classList.contains('el-step__icon-inner') ? e.target.parentNode : e.target;

      if(target.step != this.activeStep) {
        if(target.step == 0) {
          this.activeStep = target.step;
        }
        else if(target.step == 1 && this.isStep1Filled) {
          this.activeStep = target.step;
        }
        else if(target.step == 2 && this.isStep2Filled) {
          this.activeStep = target.step;
        }
      }
    },

    handleBack() {
      if(this.preMsgObj){
        this.preMsgObj.close();
      }
      if(this.activeStep > 0) this.activeStep--;
    },

    async handleNext() {
      if(this.activeStep == 0) {
        this.activeStep = 1;
      }
      else if(this.activeStep == 1) {
        this.activeStep = 2;
        await this.prepareTopics();
      }
      else if(this.activeStep == 2) {
        await this.showResults();
      }
    },

    async showResults() {
      await this.loadReportData();
      if(this.isReportDataReady){
        this.activeStep = 3;
        if(this.preMsgObj){
          this.preMsgObj.close();
        }
      }
      else{
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 0,
            showClose: true,
            customClass: 'nodata-warning-msg',
            message: 'Data not available for the period selected.',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }
      }
    },

    handleNewSearch() {
      this.activeStep = 0;
      this.isStep1Filled = false;
      this.isStep2Filled = false;
      this.selecteTopicList = [];
      this.calendarA.dateRange = { start: '', end: '' };
      this.calendarB.dateRange = { start: '', end: '' };
      if(this.$refs.calendarPickerA) this.$refs.calendarPickerA.reset();
      if(this.$refs.calendarPickerB) this.$refs.calendarPickerB.reset();
    },

    async prepareTopics() {
      this.topicList = [];
      if(!this.loading) {  
        this.loading = true;
        this.noTopic = false;
        let resTopics = await this.fetchChatTopics({ dateRanges: this.getCalendarDateRange(), maxTopics: (this.selecteTopicList != undefined) ? 1000 : null});
        if(resTopics && resTopics.status==200 && resTopics.data) {
          let topics = resTopics.data.map(el => {
            return {key: el.topicDisplayName, label: el.topicDisplayName, mergedTopics: el.mergedTopics}
          });

          // check valid selected topics
          if(this.selecteTopicList) {
            let invalidTopics = [];
            let topicKeys = topics.map(el => el.key);
            this.selecteTopicList.forEach(el => {
              if(!topicKeys.includes(el.key)) {
                invalidTopics.push(el.label);
              }
            });
          }
          this.topicList = topics;
        }
        if(this.topicList.length == 0){
          this.noTopic = true;
        }
        else {
          this.noTopic = false;
        }
        this.loading = false;   
      }
    },

    async loadReportData() {
      this.loading = true;
      this.isReportDataReady = false;

      let resPerformance = await this.fetchChatPerformance({ dateRanges: this.getCalendarDateRange(), topics: this.selecteTopicList });
      if(resPerformance && resPerformance.status==200 && resPerformance.data && resPerformance.data.datasetA) {
        let datasetA = resPerformance.data.datasetA;
        let datasetB = resPerformance.data.datasetB;
        
        this.performanceDataA = this.preparePerformanceData(datasetA);
        if(this.performanceDataA) {
          this.chartDataA = this.performanceDataA.chartData;
          if(this.chartDataA && this.chartDataA.trend) {
            this.chartDataA.trend.forEach(item => {
              item.sumVolumeDMValue = (item.sumVolume!=null ? item.sumVolume * this.$store.getters.xnumber : item.sumVolume);
            })
          }
        }

        this.performanceDataB = this.preparePerformanceData(datasetB);
        if(this.performanceDataB) {
          this.chartDataB = this.performanceDataB.chartData;
          if(this.chartDataB && this.chartDataB.trend) {
            this.chartDataB.trend.forEach(item => {
              item.sumVolumeDMValue = (item.sumVolume!=null ? item.sumVolume * this.$store.getters.xnumber : item.sumVolume);
            })
          }
        }
      }
      
      this.isReportDataReady = true;
      this.loading = false;
    },

    async handleFilterChange() {
      if(this.activeStep == 2) {
        await this.prepareTopics();
        setTimeout(() => {
          if(this.$refs.topicsPicker) {
            this.$refs.topicsPicker.handleRemovekAll();
          }
        }, 100);
      }
      if(this.activeStep == 3) {
        this.selecteTopicList = [];
        this.topicList = [];
        
        let resTopics = await this.fetchChatTopics({ dateRanges: this.getCalendarDateRange() });
        if(resTopics && resTopics.status==200 && resTopics.data) {
          let topics = resTopics.data.map(el => {
            return {key: el.topicDisplayName, label: el.topicDisplayName, mergedTopics: el.mergedTopics}
          });
          this.selecteTopicList = topics;
          this.topicList = topics;
          if(this.$refs.topicsPicker) {
            setTimeout(() => {
              this.$refs.topicsPicker.handleCheckAllChange();
            }, 100);
            setTimeout(() => {
              this.$refs.topicsPicker.addItems();
            }, 300);
          }
        }
  
        await this.loadReportData();
      }
    },

    updateSelectedTopics(topics) {
      this.selecteTopicList = topics;      
    },

    preparePerformanceData(rawData) {
      if(!rawData.trend) {
        return {
          chartData: null,
          tableData: {}
        };
      }
      else{
        let tableData = {
          handlingTime: rawData.avgAgentHandleTime,
          responseTime: rawData.avgAgentResponseTime,
          chatVolumeDMValue: (rawData.totalVolume!=null ? rawData.totalVolume * this.$store.getters.xnumber : rawData.totalVolume),
        };

        //prepare chart data
        let chartData = {
          trend: rawData.trend,
          info: {
            'sumVolumeDMValue': {label: 'Chart Volume', value: tableData.chatVolumeDMValue},
            'sumAgentHandleTime': {label: 'Handle Times', value: tableData.handlingTime},
            'sumAgentResponseTime': {label: 'Response Times', value: tableData.responseTime},
          }
        }

        return {
          chartData: chartData,
          tableData: tableData
        }
      }
    },

    async refreshPage() {
      if(this.activeStep == 2) {
        await this.prepareTopics();
      }
      if(this.activeStep == 3) {
        this.handleNewSearch();
      }
    }
  },

  async mounted() {
    setTimeout(()=> {
      if(this.$refs.stepNav) {
        this.$refs.stepNav.steps.forEach((step, index) => {
          let el = step.$el.querySelector('.el-step__icon');
          el.step = index
          el.removeEventListener('click', this.handleStepClick)
          el.addEventListener('click', this.handleStepClick)
        });
      }
    }, 300)

    if(this.selecteTopicList && this.selecteTopicList.length > 0) {      
      this.activeStep = 3;
      await this.prepareTopics();
      this.showResults();
    }
    else {
      this.activeStep = 0;
    }
  },

  async created() {
    this.initDate = new Date();
    if(this.$root.preMsgObj) {
      this.$root.preMsgObj.close();
    }
    if(this.dateRanges) {
      this.calendarA.dateRange = this.dateRanges.dateRangeA;
      this.calendarB.dateRange = this.dateRanges.dateRangeB;
    }

    if(this.topics) {
      this.selecteTopicList = this.topics;
    }

    this.$router.currPageComponent = this;
    // listen events from other components
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if(this[event.name]) this[event.name]();
    })
  },

  beforeDestroy() {
    this.handleNewSearch();
  }
});
</script>

<style lang="scss">
.wy-interactions-compare-metrics {
  min-width: 1200px;
  max-width: 100%;
  min-height: 500px;
  padding-right: 4px;
  border: unset;
  .next-btn {
    display: inline-block;
    width: 140px;
  }

  .wy-page-title {
    margin-bottom: 40px;
    line-height: 0.8;
    height: 25px;
  }

  .wy-page-title-small {
    display: none;
    color: var(--site-font-secondary-color);
    font-size: 15px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 400;
  }

  .step-next {
    display: inline-block;
    // background-image: url('../../../assets/icons/icon_button_next.svg');
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-color: #214586;
    box-shadow: 0px 3px 6px #00000029;
    line-height: 11px;
    padding: 12px 12px 12px 12px;
    min-width: 113px;
    cursor: pointer;
    font-weight: bold;
    border-color: #214586;
  }

  .step-back {
    display: inline-block;
    background: url('../../../assets/icons/icon_button_previous.svg');
    background-repeat: no-repeat;
    background-position: left 9px;
    background-size: 8px;
    border: 0px solid red;
    padding: 6px 20px 6px 20px;
    color: #214586;
    font-weight: bold;
    margin-right: 0px;
    font-size: 15px;
    cursor: pointer;
  }

  .step-cancel {
    color: #214586;
    font-weight: bold;
    font-size: 15px;
    padding: 6px 0px 6px 0px;
    cursor: pointer;
    margin-top: 7px;
  }
  
  .wy-page-picker {
    //max-width: 1130px;
    box-shadow: 0px 2px 6px #0000001A;
    border-radius: 10px;
    background-color: #fff;
    padding: 20px 20px 30px 20px;
    border: 0px solid red;

    .step-content {
      border: 0px solid green;
      padding-top: 0px;

      .step-title {
        font-size: 30px;
        font-weight: 500;
        text-align: center;
        padding: 45px 0px 0px 0px;
        color: #002852;
      }

      .select-date-range-title {
        text-align: center;
        padding: 15px 0px 7px 0px;
        font-size: 12px;
        font-weight: 500;
      }

      .div-no-topics-icon {
        background-image: url('../../../assets/icons/icon_no_data.svg');
        height: 160px;
        background-repeat: no-repeat;
        background-size: 6%;
        background-position: center;
        width: 100%;
      }
      .div-no-topics-header {
        font-size: 18px;
        text-align: center;
        margin-top: 10px;
        padding: 3px 10px 3px 10px;
        font-weight: 500;
        color: #002852;
      }
      .div-no-topics-desc {
        font-size: 15px;
        text-align: center;
        margin-top: 10px;
        padding: 3px 400px 59px 400px;
        font-weight: 400;
        color: #002852;
      }
    }

    .selected-date-rangeA {
      color: #214586;
      font-size: 12px;
      text-align: center;
      width: 33.333%;
      display: inline-block;
    }

    .selected-date-rangeA.is-success {
      color: #10A29B;
    }

    .selected-date-rangeB {
      text-align: center;
      color: #214586;
      font-size: 12px;
      width: 33.333%;
    }

    .selected-date-rangeB.is-success {
      color: #10A29B;
    }

    .div-step1-select-range {
      display: inline-flex;
      width: 100%;
    }

    .el-step.filled {
      .el-step__icon.is-text {
        cursor: pointer;
      }
    }

    .el-col-14 {
    width: 65%;
    padding: 10px 0px 0px 20px;
    }

    .el-col-6 {
    width: 18%;
    margin-top: 4px;
    }

    .el-step {
      .el-step__head.is-success {
        border-color: #10A29B;

        .el-step__icon.is-text {
          border: 0;
          background-color: #10A29B;
          color: #fff;
          cursor: pointer;
        }
      }
      .el-step__title.is-success {
        color: #10A29B;
      }

      .el-step__head.is-process {
        border-color: #214586;

        .el-step__icon.is-text {
          border: 0;
          background-color: #214586;
          color: #fff;
        }
      }
      .el-step__title.is-process {
        color: #214586;
      }

      .el-step__head.is-wait {
        border-color: #636363;

        .el-step__icon.is-text {
          border: 2;
          border-color: #636363;
          background-color: #fff;
          color: #636363;
        }
      }
      .el-step__title.is-wait {
        color: #636363;
      }
    }
  }

  .vfc-popover-container {
    margin-top: 30px;
    .vfc-main-container {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1) !important;
      background: #FFF;
      border-radius: 4px;    
      max-width: 1500px;
      height: 280px;
      margin: 10px auto;  

      .vfc-separately-navigation-buttons.vfc-space-between {
        margin-top: -22px;
      }

      .vfc-calendar {
        border-right: 1px solid #ddd;        
      }
      .vfc-calendar:last-child {
        border-right: none;
      }

      .vfc-top-date.vfc-center {
        margin: 15px 25px 10px 25px;
      }

      .vfc-dayNames {
        line-height: 27px;
        background-color: #EBF4FD;        
        .vfc-day {
          color: #214586;
          font-size: 12px;
          font-weight: 500;
        }
      }

      .vfc-week .vfc-day span.vfc-span-day {
        display: inline-block;
        text-align: center;
        width: 27px;
        line-height: 27px;
        border-radius: 50%;
        margin: 0;
        vertical-align: middle;
        font-size: 15px;
      }

      .vfc-week .vfc-day span.vfc-span-day.vfc-today {
        background-color: #fff;
        color: #214586;
        font-weight: 500;
      }
      .vfc-week .vfc-day span.vfc-span-day.vfc-marked {
        color: #ffffff;
        // background-color: #004A87 !important;
      }
      .vfc-week .vfc-day span.vfc-span-day.vfc-marked:before {
        background-color: #214586 !important;
      }
      .vfc-week .vfc-day .vfc-base-end {
        display: none;
        background-color: #214586 !important;
      }
      .vfc-week .vfc-day .vfc-base-start {
        display: none;
        background-color: #214586 !important;
      }
      .vfc-week .vfc-day span.vfc-span-day.vfc-hide {
        color: #FFF;
        background-color: #FFF !important;
        display: none;
      }
      .vfc-week .vfc-day span.vfc-span-day.vfc-hide:before {
        color: #FFF;
        background-color: #FFF !important;
        display: none;
      }
      .vfc-week .vfc-day span.vfc-span-day.vfc-marked.vfc-borderd:before, .vfc-week .vfc-day span.vfc-span-day.vfc-marked.vfc-start-marked:before, .vfc-week .vfc-day span.vfc-span-day.vfc-marked.vfc-end-marked:before {
        border-radius: 50%;
        background-color: #000 !important;
      }
      .vfc-week .vfc-day span.vfc-span-day.vfc-marked {
        // background-color: #214586 !important;
        background-color: transparent !important;
      }
      .vfc-disabled:not(.vfc-today) { 
        background:
         linear-gradient(to top left,
             rgba(0,0,0,0) 0%,
             rgba(0,0,0,0) calc(50% - 0.8px),
             rgba(165, 165, 165, 0.658) 50%,
             rgba(0,0,0,0) calc(50% + 0.8px),
             rgba(0,0,0,0) 100%),
      }
      .vfc-separately-navigation-buttons div .vfc-arrow-left {
        width: 12px;
        height: 12px;
        border-top: 2px solid;
        border-right: 2px solid;
        border-left: 0px;
        -webkit-transform: rotate(-135deg);
        transform: rotate(-135deg);
      }

      .vfc-separately-navigation-buttons div .vfc-arrow-left.vfc-disabled {
        border-color: #dddddd;
        background: unset
      }
      .vfc-separately-navigation-buttons div .vfc-arrow-right.vfc-disabled {
        border-color: #dddddd;
        background: unset
      }
      // .vfc-week .vfc-day span.vfc-span-day.vfc-disabled {
      //   opacity: 0;
      // }
    }
  }

  .el-loading-mask {
    opacity: unset;
    background-color: unset;
    left: -5px;
    .el-loading-spinner {
      top: 35%;
      background: var(--site-loading-icon);
      background-repeat: no-repeat;
      background-size: 25px;
      background-position: center;    
      .circular {
        display: inline-block;
        width: 90px;
        height: 90px;
      }
      .path {
        -webkit-animation: loading-dash 2s ease-in-out infinite;
        animation: loading-dash 2s ease-in-out infinite;
        stroke-dasharray: 90,150;
        stroke-dashoffset: 0;
        stroke-width: 2.5 !important;
        stroke: #0C2837 !important;
        stroke-linecap: round; 
      }
      .el-loading-text {
        display: none;
      }
    }
    .el-loading-spinner .circular {
      display: none;
    }
  }
}
.wy-interactions-compare-metrics .vfc-popover-container .vfc-main-container .vfc-week .vfc-day span.vfc-span-day.vfc-marked.vfc-start-marked:before, .wy-interactions-compare-metrics .vfc-popover-container .vfc-main-container .vfc-week .vfc-day span.vfc-span-day.vfc-marked.vfc-end-marked:before {
    border-radius: 50%;
    background-color: #000 !important;
    // width: 27px;
    // height: 27px;
    // left: 9px;
    // top: 0px;
    margin: 0px;
    width: 27px;
}
.vfc-week .vfc-day .vfc-base-start {
  width: 65% !important;
}

.vfc-week .vfc-day .vfc-base-end {
  display: none;
  background-color: #214586 !important;
  /* border-radius: 50% !important; */
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  width: 59% !important;
}
</style>